import { render, staticRenderFns } from "./TabBeneficiary.vue?vue&type=template&id=2d6af555&"
import script from "./TabBeneficiary.vue?vue&type=script&lang=js&"
export * from "./TabBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports